module.exports = __webpack_public_path__ + "static/media/sm.f859e5c9.svg";